export class Path {
    'path';
    'pathType';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "path",
            "baseName": "path",
            "type": "string",
            "format": ""
        },
        {
            "name": "pathType",
            "baseName": "pathType",
            "type": "PathType",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return Path.attributeTypeMap;
    }
    constructor() {
    }
}
